"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BaseProvider = void 0;
var BaseProvider = function () {
  function BaseProvider() {
    this.observers = [];
  }
  Object.defineProperty(BaseProvider.prototype, "state", {
    get: function get() {
      return this._state;
    },
    enumerable: false,
    configurable: true
  });
  BaseProvider.prototype.setState = function (state) {
    this._state = state;
    this.emitState();
  };
  BaseProvider.prototype.emitState = function () {
    var _this = this;
    this.observers.forEach(function (ob) {
      ob(_this.state);
    });
  };
  BaseProvider.prototype.subscribe = function (func) {
    var _this = this;
    if (this.observers.indexOf(func) < 0) {
      this.observers.push(func);
      func(this.state);
    }
    return function () {
      var index = _this.observers.indexOf(func);
      if (index > -1) {
        _this.observers.splice(index, 1);
      }
    };
  };
  BaseProvider.__is_base_provider__ = true;
  return BaseProvider;
}();
exports.BaseProvider = BaseProvider;